const form = document.querySelector('form');
const rules = {
    "Contact.FirstName": {test: "notEmpty"},
    "Contact.Surname": {test: "notEmpty"},
    "Contact.Email": {test: "validEmail"},
    "Message": {test: "notEmpty"},
}
const errorMessage = form.querySelector('p.message');
const validationMessage = document.getElementById('validationError');
const submitBtn = form.querySelector('input[type="submit"]');

for (let [item, value] of Object.entries(rules)) {
    const formelement = form.querySelector('[name="' + item + '"]');
    const holder = formelement.closest('.field');
    holder.querySelector('label').innerText += ' *';

    formelement.setValid = () => {
        holder.classList.remove('invalid');
        holder.classList.add('valid');
    }

    formelement.setInvalid = () => {
        holder.classList.remove('valid');
        holder.classList.add('invalid');
        validationMessage.classList.remove('d-none');
        submitBtn.setAttribute('disabled', 'disabled');
        form.classList.add('invalid');
    }

    switch (value.test) {
        case "validEmail":
            formelement.type = 'email';
            formelement.validate = function() {
                if(this.checkValidity()) {
                    this.setValid();
                } else {
                    this.setInvalid()
                }
                form.isValid();
            }
            formelement.addEventListener("blur", formelement.validate);
            break;
            case "notEmpty":
            formelement.validate = function() {
                if(!!this.value){
                    this.setValid();
                } else {
                    this.setInvalid();
                }
                form.isValid();
            }
            formelement.addEventListener("keyup", formelement.validate);
            formelement.addEventListener("blur", formelement.validate);
            break;
        case "checked":
            formelement.validate = function() {
                if(this.checked){
                    this.setValid();
                } else {
                    this.setInvalid();
                }
                form.isValid();
            }
            formelement.addEventListener("click", formelement.validate);
            break;
    }
}

form.validate = () => {
    form.querySelectorAll(".invalid").forEach((e, i) => {
        console.log(e,i);
        this.validate;
    });
}

form.isValid = () => {
    if(form.querySelectorAll(".valid").length === Object.entries(rules).length){
        validationMessage.classList.add('d-none');
        form.classList.remove('invalid');
        submitBtn.removeAttribute('disabled');
        return true;
    } else {
        return false;
    }
}

form.addEventListener('submit', sendData);


async function sendData(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    form.validate();
    if(!form.isValid()){
        return;
    }

    const data = new URLSearchParams(new FormData(form)).toString();
    const url = form.getAttribute('action');

    errorMessage.style.display = "none";
    try {
        const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-requested-with': "XMLHttpRequest"
                    },
                    body: JSON.stringify(data)
                });
            if (!response.ok) {
                throw new Error(`Response status: ${response.status}`);
                errorMessage.text = response.status;
                errorMessage.style.display = "block";
            }
        const result = await response.json();

        validationMessage.innerHTML = "";
        for (const item of result) {
            const p = document.createElement("p");
            p.classList.add(item.messageType);
            p.innerText = item.message;
            validationMessage.append(p);
        }
        validationMessage.classList.remove("d-none");
        validationMessage.style.marginLeft = 0;
        validationMessage.style.width = "100%";
        form.scrollIntoView();
        form.replaceWith(validationMessage);
        //window.scrollTo(0, 0);

    } catch (error) {
        console.log(error.message);
    }
}
